import getByPath from 'getbypath';
export const useErrorHandlerUtils = (v$) => {
	const hasError = (path, error) => {
		if (error) {
			return getByPath(v$.value, `${path}.$dirty`) && getByPath(v$.value, `${path}.${error}.$invalid`);
		} else {
			return getByPath(v$.value, `${path}.$dirty`) && getByPath(v$.value, `${path}.$invalid`);
		}
	};
	const validateField = (path) => {
		setTimeout(() => {
			const touchFn = getByPath(v$.value, `${path}.$touch`);
			touchFn?.();
		}, 500);
	};
	const getErrorMessage = (path, error) => {
		if (error) {
			return getByPath(v$.value, `${path}.$dirty`) && getByPath(v$.value, `${path}.${error}.$message.value`);
		} else {
			return getByPath(v$.value, `${path}.$dirty`) && getByPath(v$.value, `${path}.$errors.0.$message`);
		}
	};
	return {
		hasError,
		validateField,
		getErrorMessage
	};
};
